module.exports = __webpack_public_path__ + "static/media/intro-hero-people.ee0d11fa.png";